// Used in window resize events to add delay before the callback function fires to prevent preformance issues.
let resizeTimer = 200;

/*button colors*/
let confirmationColor = "green"; //used for confirmation buttons/resend code and for add address
let editAddressColor = "orange";
let deleteAddressColor = null;
let addProductToCartColor = "orange";
let searchBarColor = "black";
let backColor = null;
let activateAccountColor = "orange";
let deleteFromCartColor = null;// not used, color to button
let redirectColor = "orange"; //used for sign up and sign in buttons in reset/signIn/register
let secondaryButtonColor = "orange";
let redirectGuestCheckoutColor="black";

//taken from semantic-ui-react Responsive breakpoints around the 12+ days since they plan to depracate it(august 12, 2020)
let wideScreenMinWidth = 1920;
let largeScreenMaxWidth = 1919;
let largeScreenMinWidth = 1200;
let computerMaxWidth = 1199;//this wasn't taken from semantic ui react but inferred from their largescreen min width
let computerMinWidth = 992;
let tabletMaxWidth = 991;
let tabletMinWidth = 768;
let mobileMaxWidth = 767;
let mobileMinWidth = 320;



export {
	resizeTimer,
	confirmationColor,
	editAddressColor,
	deleteAddressColor,
	backColor,
	addProductToCartColor,
	searchBarColor,
	deleteFromCartColor,
	activateAccountColor,
	redirectColor,
	secondaryButtonColor,
	redirectGuestCheckoutColor,
	wideScreenMinWidth,
	largeScreenMaxWidth,
	largeScreenMinWidth,
	computerMaxWidth,
	computerMinWidth,
	tabletMaxWidth,
	tabletMinWidth,
	mobileMaxWidth,
	mobileMinWidth,
};